import { FC, ReactElement } from 'react';

import { RootState } from 'store/rootReducer';

import { useAppSelector } from 'hooks/defaultStoreHooks';

import { RaaExpandablePreview } from 'raa-react';

import { DrawerSection } from 'components/drawerSections/DrawerSections';

import { BebyggelseobjektUtkast } from 'models';

const SammansattBebyggelseSkyddstypSection: FC<{ utkast: BebyggelseobjektUtkast }> = ({ utkast }): ReactElement => {
  const domaner = useAppSelector((state: RootState) => state.bebyggelseobjektDomaner.data);
  const doman = domaner?.skyddstyper.find((doman) => doman.skyddstyp === utkast.skydd?.skyddstyp);

  return (
    <DrawerSection>
      <h2 className="tw-heading-md tw-mb-4">{doman?.namn ?? 'TBD'}</h2>
      {doman?.forklaring && <p className="tw-mb-4 tw-font-semibold">{doman.forklaring}</p>}

      <div className="tw-flex tw-items-center tw-gap-2">
        <p className="tw-font-semibold">Ansvarig myndighet</p>
        <span>{doman?.ansvarig_myndighet ?? <>&ndash;</>}</span>
      </div>

      <p className="tw-mb-1 tw-mt-2 tw-font-semibold">Motivering till beslutet</p>
      <RaaExpandablePreview height={48} ariaLabel="Motivering till beslutet för utkastet">
        {utkast.skydd?.motivering ?? 'Motivering ej registrerad. Kontakta ansvarig organisation'}
      </RaaExpandablePreview>
    </DrawerSection>
  );
};

export default SammansattBebyggelseSkyddstypSection;
